export const experienceData = [
    {
        id: 1,
        company: 'Chipcolate',
        jobtitle: 'Full Stack Developer',
        startYear: 'Jan 2025',
        endYear: 'Present',
        description: 'Building and running web platforms end to end: TypeScript APIs and services, React dashboards, PostgreSQL, and the Docker, Kubernetes and Terraform setup behind them.'
    },
    {
        id: 2,
        company: 'Freelancer.com / Upwork.com',
        jobtitle: 'Penetration Tester & Security Analyst',
        startYear: '2024',
        endYear: 'Jan 2025',
        description: 'Web application and network penetration tests for clients, delivered with written reports and concrete remediation steps.'
    },
    {
        id: 3,
        company: 'Freelancer.com / Upwork.com',
        jobtitle: 'Full Stack Developer',
        startYear: '2023',
        endYear: '2024',
        description: 'Built and maintained websites and web apps for clients, covering frontend, backend and deployment.'
    },
    {
        id: 4,
        company: 'BS Biro, Zenica',
        jobtitle: 'Front-End Developer',
        startYear: '2019',
        endYear: '2021',
        description: 'Built responsive websites and interfaces for client projects with HTML, CSS and JavaScript.'
    },
]
